// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2cq_K","title":"Header_title__1mCs7","left":"Header_left__2n19A","clinicName":"Header_clinicName__ckzm_"};